import i18n from "../../../../Utils/i18next/i18next";
import store from "../../../../store";
import { NotificationManager } from "react-notifications";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { cloneDeep, set } from "lodash";
import { updateDashboardByName } from "../../../../Utils/Sockets";

const { t } = i18n;

export const onSubmit = async (values, props) => {
  const { projectReducer } = store.getState();
  const {
    updateTableRegistry,
    loadData,
    update,
    updateSingleRegistry,
    uuid,
    initialValues,
  } = props;

  const data = cloneDeep(values);

  let payload;

  if (update) {
    const res = await GlobalAuthFetch({
      path: `/project/${uuid}/task/${data?.uuid}`, // Aktualizujemy konkretne zadanie
      method: "PUT",
      data,
    });
    payload = res.payload;
  }

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);

    return;
  }

  props.setErrorHeader(0, false);

  //Succes nofify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();

  props.handleHide();
};

export const onValidate = (values, props) => {
  const errorsStep0 = {};


  

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    !props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }

  return { ...errorsStep0 };
};
